// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__mQQXC","fixed":"styles_fixed__FXFrc"};